import React from "react";
import styles from "./Fab.module.scss";


const Fab = (props) => {
    const squre = [styles.fab_container]
    if (props.fab_open) {
        squre.push("rollback")
    } else {
        squre.push("hide_fab")
    }
    return (
        <div className={styles.main_fab_container} style={{
            background: props.mapView ? props.hover ? 'white' :'#081C48'  : props.hover ?  '#081C48' : 'white'
        }}>
            <div onClick={() => {
                props.pick_fab("ZONE")
            }} id="globe" style={{
                color: props.fab === "ZONE" ? "#5e90ff" : props.mapView ?  (props.hover ?  '#081C48' : 'white') : (props.hover ? "whitesmoke" : "#081C48" ) ,
            }} className={squre.join(" ")}>
                <div style={{
                    display: 'flex',
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "center"
                }}>
                    <p> <i class="fas fa-globe"></i></p>
                    <small>Zone</small>
                </div>
            </div>
            <div id="squre_half" style={{
                color: props.fab === "PLOT" ? "#ff4d4d" : props.mapView ? (props.hover ?  '#081C48' : 'white') : (props.hover ? "whitesmoke" : "#081C48" ),
            

            }} onClick={() => {
                
                props.pick_fab("PLOT")
       

            }} className={squre.join(" ")}>
                <div style={{
                    display: 'flex',
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "center"
                }}>
                    <p> <i class="far fa-square"></i></p>
                    <small>Plot</small>
                </div>
            </div>
            <div id="squre" style={{
                color: props.fab === "CROPLAND" ? "#fff000" : props.mapView ? (props.hover ?  '#081C48' : 'white') : (props.hover ? "whitesmoke" : "#081C48" ),
            }} onClick={() => {
               
                props.pick_fab("CROPLAND")
         
            }} className={squre.join(" ")}>
                <div style={{
                    display: 'flex',
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "center"
                }}>
                    <p> <i class="fas fa-square-full"></i></p>
                    <small>Cropland</small>
                </div>
            </div>
            <div id="delete" style={{
               
                color: props.fab === "DELETE" ? "#ff4d4d" : props.mapView ? (props.hover ?  '#081C48' : 'white') : (props.hover ? "whitesmoke" : "#081C48" ),
            }} onClick={() => {
              
                props.pick_fab("DELETE")
              
            }} className={squre.join(" ")}>
                <div style={{
                    display: 'flex',
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "center"
                }}>
                    <p> <i class="far fa-trash-alt"></i></p>
                    <small>Delete</small>
                </div>
            </div>
        </div>
    )
}

export default Fab;